import * as React from "react";
import { Link } from "react-router-dom";

import styles from "./Error404Page.module.scss";

export default function Error404Page() {
  return (
    <main className={styles.main}>
      <div>
        <p>お探しのページが見つかりませんでした</p>
        <Link to={"/"}>ホーム画面に戻る</Link>
      </div>
    </main>
  );
}
